import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("[ErrorBoundary]", error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          minHeight="100vh"
          gap={2}
          sx={{ color: "text.secondary", px: 2 }}
        >
          <ErrorOutlineIcon sx={{ fontSize: 72, color: "error.main" }} />
          <Typography variant="h5" fontWeight={600} color="text.primary">
            Algo deu errado
          </Typography>
          <Typography variant="body2" textAlign="center" maxWidth={360}>
            Ocorreu um erro inesperado na aplicação. Recarregue a página e tente
            novamente.
          </Typography>
          <Button
            variant="outlined"
            color="error"
            onClick={() => window.location.reload()}
            sx={{ mt: 1 }}
          >
            Recarregar
          </Button>
        </Box>
      );
    }

    return this.props.children;
  }
}
